import React from 'react';
import { AccountData, AccountStatus } from './types';

export const styleCache: Record<string, React.CSSProperties> = {};

export function s(css: string): React.CSSProperties {
  if (!css) return {};
  if (styleCache[css]) return styleCache[css];
  const obj: Record<string, string> = {};
  const decls = css.split(';');
  for (let i = 0; i < decls.length; i++) {
    const colon = decls[i].indexOf(':');
    if (colon === -1) continue;
    const prop = decls[i].slice(0, colon).trim();
    const val = decls[i].slice(colon + 1).trim();
    if (!prop || !val) continue;
    const camel = prop.startsWith('--') ? prop : prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    obj[camel] = val;
  }
  styleCache[css] = obj;
  return obj;
}

export function money(n: number, dec?: boolean): string {
  return (n < 0 ? '-$' : '$') + Math.abs(n).toLocaleString('en-US', {
    minimumFractionDigits: dec ? 2 : 0,
    maximumFractionDigits: dec ? 2 : 0
  });
}

export function compact(n: number): string {
  return n >= 1e6 ? '$' + (n / 1e6).toFixed(2) + 'M' : n >= 1e3 ? '$' + (n / 1e3).toFixed(1) + 'K' : '$' + Math.round(n);
}

export function formatDate(t: number): string {
  return new Date(t).toLocaleDateString('en-GB');
}

export function vp(a: AccountData, end: number) {
  return a.payouts.filter(p => p.verified && p.date <= end);
}

export function consistent(a: AccountData, end: number) {
  return a.stage === 'Funded' && vp(a, end).length >= 2 && a.consistencyScore >= 75;
}

export function statusOf(a: AccountData): AccountStatus {
  if (a.paused) return 'Paused';
  if (a.drawdown <= -8) return 'Recovery';
  if (a.drawdown <= -5 || a.riskCompliance < 85) return 'Attention';
  if (consistent(a, Infinity) && a.consistencyScore >= 85 && a.drawdown > -3 && a.riskCompliance >= 90) return 'Scale Ready';
  return 'Normal';
}

export const REACH: Record<string, (a: AccountData, end: number) => boolean> = {
  Developing: () => true,
  Challenge: a => ['Challenge', 'Verified', 'Funded'].includes(a.stage),
  Verified: a => ['Verified', 'Funded'].includes(a.stage),
  Funded: a => a.stage === 'Funded',
  Payout: (a, e) => a.stage === 'Funded' && vp(a, e).length > 0,
  Consistent: (a, e) => consistent(a, e),
  'Scale Ready': a => statusOf(a) === 'Scale Ready'
};
